export default __webpack_public_path__ + "static/media/herald.3ca4cc88.png";